// ExportButton.js
import React from 'react';
import SqftStore from "../../../canvas/store/sqftStore";

const ExportButton = () => {
  const exportScene = () => {
    const exporter = new window.GLTFExporter();
    const viewGL = SqftStore.viewGL;

    if (viewGL && viewGL.scene) {
      exporter.parse(viewGL.scene, (gltf) => {
        const blob = new Blob([JSON.stringify(gltf)], {type: 'text/plain'});
        const link = document.createElement('a');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.href = URL.createObjectURL(blob);
        link.download = 'scene.gltf';
        link.click();
      });
    } else {
      console.error('GLBViewer instance or scene not found');
    }
  };

  return (
    <button className="exportBtn btn" onClick={exportScene}>Export Scene</button>
  );
};

export default ExportButton;
